/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface MainMenuNode
 */
export interface MainMenuNode {
  /**
   *
   * @type {string}
   * @memberof MainMenuNode
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof MainMenuNode
   */
  shortText: string
}

/**
 * Check if a given object implements the MainMenuNode interface.
 */
export function instanceOfMainMenuNode(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'shortText' in value

  return isInstance
}

export function MainMenuNodeFromJSON(json: any): MainMenuNode {
  return MainMenuNodeFromJSONTyped(json, false)
}

export function MainMenuNodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainMenuNode {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    shortText: json['shortText'],
  }
}

export function MainMenuNodeToJSON(value?: MainMenuNode | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    shortText: value.shortText,
  }
}
